import styled from "@emotion/styled";

export const FlexColumnBetween = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
`;
